import { useState, useEffect } from 'react';
import RichTextEditor from '../RichTextEditor';
import { apiGet, apiPut } from '../api';

export default function CookiesPolicySection() {
  const [data, setData] = useState({
    cookies_pt_text: ''
  });
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const result = await apiGet('policies.php');
      if (result) {
        setData({
          cookies_pt_text: result.cookies_pt_text || ''
        });
      }
    } catch (err) {
      setMessage('Erro ao carregar dados');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSave = async () => {
    setIsSaving(true);
    setMessage('');

    try {
      // First fetch current data to preserve privacy_policy_pt_text
      const currentData = await apiGet('policies.php');

      const result = await apiPut('policies.php', {
        privacy_policy_pt_text: currentData?.privacy_policy_pt_text || '',
        cookies_pt_text: data.cookies_pt_text
      });

      setMessage(result.success ? 'Salvo com sucesso!' : 'Erro ao salvar');
    } catch (err) {
      setMessage(err instanceof Error ? err.message : 'Erro ao salvar dados');
    } finally {
      setIsSaving(false);
    }
  };

  if (isLoading) return <div className="p-4 text-gray-500">Carregando...</div>;

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-900">Política de Cookies</h2>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <p className="text-sm text-blue-700">
          📋 Este conteúdo aparece quando o utilizador clica em <strong>"COOKIES"</strong> no rodapé do site.
          O texto é exibido num modal (janela pop-up).
        </p>
        <p className="text-xs text-blue-600 mt-2">
          💡 Use o editor avançado para formatar o texto. Selecione uma palavra e clique no botão 🔗 para torná-la num link clicável.
        </p>
      </div>

      <RichTextEditor
        value={data.cookies_pt_text}
        onChange={(html) => setData({ ...data, cookies_pt_text: html })}
        label="Conteúdo da Política de Cookies"
      />

      <div className="bg-amber-50 border border-amber-200 rounded-lg p-3">
        <p className="text-xs text-amber-700">
          ⚠️ <strong>Dica:</strong> Para adicionar um link clicável, selecione o texto desejado e clique no ícone de link (🔗) na barra de ferramentas.
        </p>
      </div>

      {data.cookies_pt_text && (
        <div className="bg-gray-50 p-4 rounded-lg">
          <h3 className="font-semibold text-gray-800 mb-3 flex items-center gap-2">
            <span>👁️</span>
            Pré-visualização
          </h3>
          <div
            className="bg-white border border-gray-200 rounded-lg p-6 max-h-[400px] overflow-y-auto policy-content"
            style={{
              fontFamily: "'Prompt-Light', 'Prompt', sans-serif",
              color: '#000000',
              fontSize: '15px',
              lineHeight: '1.8',
              textAlign: 'justify',
              fontWeight: 300
            }}
            dangerouslySetInnerHTML={{ __html: data.cookies_pt_text }}
          />
        </div>
      )}

      {message && (
        <div className={`p-4 rounded-lg ${message.includes('sucesso') ? 'bg-green-50 text-green-700 border border-green-200' : 'bg-red-50 text-red-700 border border-red-200'}`}>
          {message}
        </div>
      )}

      <button
        onClick={handleSave}
        disabled={isSaving}
        className="w-full bg-amber-600 hover:bg-amber-700 text-white font-semibold py-3 px-4 rounded-lg transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {isSaving ? 'Salvando...' : 'Salvar Alterações'}
      </button>
    </div>
  );
}
